import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import UserManager from "./UserManager";

function Team(props) {
	let {updateHeader, resetHeader, showSnackbar, bannerHeight, banner} = props;

	return (
		<UserManager
			{...props}
			updateHeader={updateHeader}
			resetHeader={resetHeader}
			showSnackbar={showSnackbar}
			banner={banner}
			bannerHeight={bannerHeight} />
	);
}

Team.propTypes = {
	history: PropTypes.object.isRequired,
	location: PropTypes.object.isRequired,
	updateHeader: PropTypes.func.isRequired,
	resetHeader: PropTypes.func.isRequired,
	showSnackbar: PropTypes.func.isRequired,
	banner: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
	bannerHeight: PropTypes.number
};

export default Team;